import Tracker from './Tracker';

const marketingBoardTracker = new Tracker('marketingBoard', {
	CLICK_EVENT: 'click'
});

export default marketingBoardTracker;
